import { createContext } from 'react';

const CurriculaContentContext = createContext();

export default CurriculaContentContext;
